export default "__VITE_ASSET__86f6f5e5__"